import { useState } from 'react'
import { HubspotBrochureDownload, SevenminuteCarousel } from '.'

const SevenMinuteWorkout = (props) => {
  return (
    <>
      <section className="contentmainN ptb0 pt-5">
        <div className="container customCampaignContainer">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
              <div className="subTextHeading text-left">You will get to learn:</div>
              <div>
                <ul className="mainbullets mt-4">
                  <li>What is the 7-Minute Workout?</li>
                  <li>Who can perform it and how effective is it?</li>
                  <li>What are the benefits of performing it?</li>
                  <li>How to perform the 7-Minute Workout?</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
              <SevenminuteCarousel />
            </div>
          </div>
        </div>
      </section>
      <div id="downloadForm"></div>
      <section className="sectionSpacing">
        <div className="container customCampaignContainer">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow"
              style={{ margin: 'auto', borderRadius: '16px', padding: '60px 30px' }}
            >
              <div className="mainHeadingN ">Download Now</div>
              <div className="innerSpace guide-form">
                <HubspotBrochureDownload formID="f7edc8bf-6aa6-44a1-9191-c2154fdb8ac2" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SevenMinuteWorkout
